export const PageHeader = ({ eyebrow, title, subtitle, actions, testId }) => (
  <div data-testid={testId} className="mb-10 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
    <div>
      {eyebrow && <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.25em] text-gold-dark">{eyebrow}</p>}
      <h1 className="font-display text-3xl font-semibold tracking-tight text-neutral-900 sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-3 max-w-2xl text-sm text-neutral-500 sm:text-base">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const Panel = ({ title, subtitle, action, className = "", children, testId }) => (
  <section data-testid={testId} className={`rounded-xl border border-neutral-200 bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:p-7 ${className}`}>
    {(title || action) && (
      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <h2 className="font-display text-lg font-semibold text-neutral-900">{title}</h2>
          {subtitle && <p className="mt-1 text-xs text-neutral-500">{subtitle}</p>}
        </div>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const KpiCard = ({ icon: Icon, label, value, hint, testId }) => (
  <div data-testid={testId} className="group rounded-xl border border-neutral-200 bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-md">
    <div className="flex items-center justify-between">
      <p className="text-xs font-medium uppercase tracking-[0.15em] text-neutral-500">{label}</p>
      {Icon && (
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gold-soft">
          <Icon className="h-4 w-4 text-gold-dark" />
        </span>
      )}
    </div>
    <p data-testid={testId ? `${testId}-value` : undefined} className="mt-4 font-display text-3xl font-semibold text-neutral-900">{value}</p>
    {hint && <p className="mt-2 text-xs text-neutral-500">{hint}</p>}
  </div>
);

export const ProgressLine = ({ value, testId }) => (
  <div data-testid={testId} className="h-1.5 w-full overflow-hidden rounded-full bg-neutral-100">
    <div className="h-full rounded-full bg-gold transition-[width] duration-500" style={{ width: `${Math.min(value, 100)}%` }} />
  </div>
);

export const Initials = ({ name, className = "h-9 w-9 text-xs" }) => (
  <div className={`flex shrink-0 items-center justify-center rounded-full bg-neutral-900 font-semibold text-gold ${className}`}>
    {name.split(" ").map((p) => p[0]).slice(0, 2).join("")}
  </div>
);

const TONES = {
  gold: "bg-gold-soft text-gold-dark border-gold/30",
  dark: "bg-neutral-900 text-white border-neutral-900",
  muted: "bg-neutral-100 text-neutral-600 border-neutral-200",
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  red: "bg-red-50 text-red-700 border-red-200",
};

export const Tag = ({ tone = "muted", children, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${TONES[tone]}`}>
    {children}
  </span>
);

export const attTone = (att) => (att >= 100 ? "green" : att >= 85 ? "gold" : "red");
